import { Button, ModalCloseButton } from "@chakra-ui/react";
import { useModal } from "contexts/ModalContext";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackCustomEvent, trackUAClickEvent } from "utils/tracking/utils";
import type { ModalProps } from "./Modal.d";

export const Modal = ({
  content,
  buttonText,
  buttonSize,
  buttonVariant,
  modalSize,
  gtmSection,
  gtmElement,
  gaLabel,
  gaPlacement,
  sbEditable,
}: SbEditableComponentProps<ModalProps>) => {
  const { openModal } = useModal();

  const trackingEvents = () => {
    trackUAClickEvent(gtmSection, gtmElement);
    trackCustomEvent({ event: "cta_click", label: gaLabel, placement: gaPlacement });
  };

  const modalContent = (
    <>
      <ModalCloseButton />
      {renderDynamicComponent(content)}
    </>
  );

  const handleOnClick = () => {
    openModal(modalContent, modalSize);
    trackingEvents();
  };

  return (
    <Button size={buttonSize} variant={buttonVariant} onClick={handleOnClick} {...sbEditable}>
      {buttonText}
    </Button>
  );
};
